import { render, staticRenderFns } from "./NewspaperPdfsList.vue?vue&type=template&id=d0f8dd66&"
import script from "./NewspaperPdfsList.vue?vue&type=script&lang=js&"
export * from "./NewspaperPdfsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports